/* ----------------------------------------
    Api Communicator
---------------------------------------- */

import axios from 'axios';
import store from '@store/store';

/**
 * Will help building routes
 */

export default class StoreDispatcher {

    /* ----------------------------------------
        Base
    ---------------------------------------- */

    static async dispatchAction(action, payload: any = null) {
        return await store.dispatch(action, payload);
    }

    /* ----------------------------------------
        Trans
    ---------------------------------------- */

    static async fetchTrans() {
        return this.dispatchAction('trans/fetch');
    }

    /* ----------------------------------------
        Settings
    ---------------------------------------- */

    static async fetchSettings() {
        return this.dispatchAction('settings/fetch');
    }

    /* ----------------------------------------
        Project
    ---------------------------------------- */

    static async fetchProject(payload: any) {
        return this.dispatchAction('project/fetch', payload)
    }

    static async fetchCurrentProject(payload: any) {
        return this.dispatchAction('project/fetchCurrent', payload)
    }

    static async updateCurrentProject(payload: any) {
        return this.dispatchAction('project/updateCurrent', payload)
    }

    static async createProject(payload: any) {
        return this.dispatchAction('project/create', payload)
    }

    /* ----------------------------------------
        User
    ---------------------------------------- */

    static async fetchUser() {
        return this.dispatchAction('user/fetch');
    }

    static async inviteUser() {
        return this.dispatchAction('user/invite');
    }

    static async fetchUserPicture() {
        return this.dispatchAction('user/fetchPicture')
    }

    /* ----------------------------------------
        Organisation
    ---------------------------------------- */

    static async createOrganisation(payload: any) {
        return this.dispatchAction('organisation/create', payload)
    }

    static async fetchOrganisationList() {
        return this.dispatchAction('organisation/fetchAll')
    }

    /* ----------------------------------------
        Organisation
    ---------------------------------------- */

    static async fetchNotifications() {
        return this.dispatchAction('notification/fetchAll')
    }

    /* ----------------------------------------
        App
    ---------------------------------------- */

    static async clearAppStore() {
        return axios.all([
            this.dispatchAction('clearApp'),
        ]).catch(error => {
            return new Error(error);
        });
    }

    static async fetchApp() {
        return axios.all([
            this.fetchTrans(),
            this.fetchSettings(),
            this.fetchOrganisationList(),
            this.fetchNotifications(),
            this.fetchUserPicture(),
        ]).catch(error => {
            return new Error(error);
        });
    }
}